import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MenuSections, TableColumn, ViewType } from '@thehubz/client/core';
import { AnyType } from '@thehubz/shared/model';
import { SelectTableColumnComponent } from '../select-table-column/select-table-column.component';

export type HeaderType =
  | 'project'
  | 'task'
  | 'assetGallery'
  | 'assetList'
  | 'scheduler'
  | 'collectionList'
  | 'collectionGallery'
  | 'collectionAssetGallery'
  | 'collectionAssetList';

@Component({
  selector: 'sp-table-wheel-setting',
  templateUrl: './table-wheel-setting.component.html',
  styleUrls: ['./table-wheel-setting.component.scss'],
})
export class TableWheelSettingComponent {
  @Input() selectedViewType!: ViewType;
  @Input() selectedViewSection2!: ViewType;
  @Input() headerType!: HeaderType;
  // table columns defined as per TableColumn model
  @Input() defaultTableCols: TableColumn[] = [];
  @Input() additionalColumns: TableColumn[] = [];
  @Input() sharedTaskStatusColumn?: TableColumn[] = [];
  @Input() menuObjects!: MenuSections[];
  @Input() gridSettingsKeySuffix = '';

  @Output() changeView = new EventEmitter<ViewType>();
  @Output() sortBy = new EventEmitter<ViewType>();
  @Output() schedulerTimePeriod = new EventEmitter<ViewType>();
  @Input() sortByNew?: boolean;

  constructor(private dialog: MatDialog) {}

  changeListView(type: AnyType) {
    switch (type) {
      case 'individual':
      case 'grouped':
      case 'kanban':
      case 'grid_4':
      case 'grid_8':
      case 'list': {
        this.changeView.emit(type);
        break;
      }
      case 'week':
      case 'month': {
        this.schedulerTimePeriod.emit(type);
        break;
      }
      case 'selectColumns': {
        this.selectColumn();
        break;
      }
      case 'sortByAlphabetically':
      case 'sortByLastCreated': {
        this.sortBy.emit(type);
        break;
      }
    }
  }

  selectColumn() {
    const dialogRef = this.dialog.open(SelectTableColumnComponent, {
      minWidth: '25%',
      data: {
        defaultTableCols: this.defaultTableCols,
        additionalColumns: this.additionalColumns,
        sharedTaskStatusColumn: this.sharedTaskStatusColumn,
        headerType: this.headerType,
      },
    });
    dialogRef.disableClose = true;
  }

  onValueChange(event: any) {
    this.sortBy.emit(event);
  }
}
